import { Reveal, SectionHeader } from "@/components/Reveal";
import { EQUIPMENT } from "@/lib/data";

const Equipment = () => (
  <section id="equipements" data-testid="equipment-section" className="relative py-24 lg:py-32 bg-[#EEF3F9]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeader
        caption="Équipements éligibles"
        title="Si ça travaille, on le finance"
        subtitle="Neuf ou d'occasion, chez un concessionnaire ou un vendeur privé : si l'équipement fait travailler votre entreprise, il est probablement admissible."
      />

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
        {EQUIPMENT.map((cat, i) => (
          <Reveal key={cat.slug} delay={(i % 3) * 0.1}>
            <article
              data-testid={`equipment-card-${cat.slug}`}
              className="group relative h-72 overflow-hidden rounded-xl border border-slate-900/10"
            >
              <img
                src={cat.image}
                alt={cat.name}
                loading="lazy"
                decoding="async"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A1220] via-[#0A1220]/40 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-6">
                <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-sky-400">
                  0{i + 1} — Admissible
                </span>
                <h3 className="font-display text-2xl font-bold uppercase tracking-tight text-white mt-1">
                  {cat.name}
                </h3>
                <p className="text-xs text-slate-400 mt-2 leading-relaxed opacity-0 translate-y-2 transition-[opacity,transform] duration-500 group-hover:opacity-100 group-hover:translate-y-0">
                  {cat.examples}
                </p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Equipment;
